/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum AudioDeviceMode {
    Tesira = 1,
    Pure = 2,
    Dummy = 3,
    Undefined = -100,
}
